import * as React from 'react';
import { useEffect } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Button, Grid, withTheme } from '@material-ui/core';

import Layout from '../Layout/Layout';
import Title from '../shared/Title/Title';
import AccountsTable from './AccountsTable';
import ConnectFrame from './ConnectFrame';
import { AscendState } from '../../ducks';
import { FETCH_ACCOUNTS } from '../../ducks/actions';
import { MxAccount } from '../../models/mx';
import routerHistory from '../../history';

type StateProps = {
  accounts: MxAccount[];
  userId: number;
};
type DispatchProps = {
  getAccounts: (userId: number) => void;
};
type AccountsTrackerProps = StateProps & DispatchProps;

// todo I'd like to automatically redirect to accounts page if user has no accounts,
//  maybe in a useEffect that waits for accounts to load

// todo about above todo I don't know if that would be best anymore as we have other things in spending tracker for how to now makes more sense to prompt user to add accounts maybe unneeded as we have how to now

const AccountsTracker = ({ getAccounts, userId }: AccountsTrackerProps) => {
  useEffect(() => {
    if (!userId) return;
    getAccounts(userId);
  }, [userId]);

  return (
    <Layout>
      <Title text="Accounts" center />
      <Grid container spacing={16}>
        <Grid item xs={12} md={6} lg={4}>
          <AccountsTable />
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={() => routerHistory.push('/spendingTracker')}
            style={{ marginTop: '20px' }}>
            Back
          </Button>
        </Grid>
        <Grid item xs={12} md={6} lg={8}>
          <ConnectFrame />
        </Grid>
      </Grid>
    </Layout>
  );
};

const mapStateToProps = (state: AscendState) => ({
  accounts: state.mx.accounts.data,
  userId: state.user.data.id,
});

// noinspection JSUnusedGlobalSymbols
const mapDispatchToProps = (dispatch: Dispatch) => ({
  getAccounts: (userId: number) => dispatch({ type: FETCH_ACCOUNTS, userId }),
});

export default withTheme()(
  connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(AccountsTracker)
);
